export const HA_PTA_HP_MERCHANDISINGMODULE = 'HA_PTA_HP_MerchandisingModuleV2';
